var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightAuditWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 10.75C16.83 14.5 13.66 17.43 9.82 17.43C5.73 17.43 2.43 14.12 2.43 10.04C2.43 6.2 5.36 3.03 9.11 2.66C7.72 3.72 6.82 5.39 6.82 7.27C6.82 10.48 9.42 13.08 12.63 13.08C14.51 13.08 16.15 12.18 17.2 10.75Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 2.55L13.45 3.92L14.82 4.42L13.45 4.92L12.95 6.29L12.45 4.92L11.08 4.42L12.45 3.92L12.95 2.55Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.82 6.67L16.16 7.6L17.09 7.94L16.16 8.28L15.82 9.21L15.48 8.28L14.55 7.94L15.48 7.6L15.82 6.67Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03 10.72H11.9",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03 13.05H10.3",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightAuditWhite);
export default __webpack_public_path__ + "static/media/night_audit_white.969638f50994c5394dfeb5b6ebe20aa7.svg";
export { ForwardRef as ReactComponent };